const getKinshipType = function (familyRelation) {
  let ktype = ''
  if (familyRelation) {
    switch (familyRelation) {
      case 1:
        ktype = 'Mamma'
        break
      case 2:
        ktype = 'Pappa'
        break
      case 3:
        ktype = 'Mormor'
        break
      case 4:
        ktype = 'Morfar'
        break
      case 5:
        ktype = 'Farmor'
        break
      case 6:
        ktype = 'Farfar'
        break
      case 7:
        ktype = 'Barn'
        break
      case 8:
        ktype = 'Barnbarn'
        break
      case 9:
        ktype = 'Syskon'
        break
      case 10:
        ktype = 'Syskonbarn'
        break
      case 11:
        ktype = 'Halvsyskon på mammas sida'
        break
      case 12:
        ktype = 'Halvsyskons barn på mammas sida'
        break
      case 13:
        ktype = 'Halvsyskon på pappas sida'
        break
      case 14:
        ktype = 'Halvsyskons barn på pappas sida'
        break
      case 15:
        ktype = 'Mammas syskon'
        break
      case 16:
        ktype = 'Pappas syskon'
        break
      case 17:
        ktype = 'Kusin (mamma)'
        break
      case 18:
        ktype = 'Kusin (pappa)'
        break
      default:
        break
    }
  }
  return ktype
}

export {
  getKinshipType
}



// WEBPACK FOOTER //
// ./src/plugins/relationhandler.js